const BREAKPOINTS = {
    'showHamburger': 1460,
}

export default BREAKPOINTS